import { useCategory } from "./Context/Category";

const AuctionTopBar = (props) => {
  const { styles } = props;
  const { breadcrumbs } = useCategory();
  const category = breadcrumbs.length
    ? breadcrumbs[breadcrumbs.length - 1]
    : null;

  return (
    <div className={styles.heading} style={{ padding: "13px" }}>
      <h1>{`${
        category ? category.Name + " - Drop Auctions" : "All Drop Auctions"
      }`}</h1>{" "}
    </div>
  );
};

export default AuctionTopBar;
